export default __webpack_public_path__ + "static/media/others_desk.de25a56d.png";